module.exports = __webpack_public_path__ + "static/award_devops.2f3a4863.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/footer/award_devops.png
// module id = 1404
// module chunks = 168707334958949